export default __webpack_public_path__ + "static/media/warwick-uni.6b8276a8.jpg";